<template>
    <!-- No visible title of its own; the shortcut bar uses the translated one. -->
    <div
        v-if="productPageStore.configurableProduct.description"
        id="product-description"
        :data-shortcut-title="$t('general.product_description.title')"
    >
        <div class="prose mt-10 max-w-full min-w-full prose-headings:mb-2" v-html="productPageStore.configurableProduct.description" />
    </div>
</template>

<script setup lang="ts">
import { useProductPageStore } from '@/stores/pages/ProductPageStore';

const productPageStore = useProductPageStore();
</script>
